import React, { memo } from 'react'

import Text from '../text/Text'

const CopyrightText = ({ brandName }) => {
  return (
    <Text
      variant='caption'
      color='text.secondary'
      label={
        <>
          Copyright &copy; {new Date().getFullYear()} {brandName}
        </>
      }
    />
  )
}

export default memo(CopyrightText)
